import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { MenuListPageRoutingModule } from "./menu-list-routing.module";

import { MenuListPage } from "./menu-list.page";
import { CardPageModule } from "../card/card.module";
import { SharedModule } from "../../shared.module";
import { FeaturedCouponPopupComponent } from "../featured-coupon-popup/featured-coupon-popup.component";
import { BodyPortalDirective } from "src/app/shared/directives/body-portal.directive";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		MenuListPageRoutingModule,
		CardPageModule,
		SharedModule,
		BodyPortalDirective
	],
	declarations: [MenuListPage, FeaturedCouponPopupComponent],
	exports: [MenuListPage],
})
export class MenuListPageModule {}
